"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.ClearButton = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var a11y_1 = require("@kaizen/a11y");
var provider_1 = require("../../../provider");
var SelectionControlButton_module_scss_1 = __importDefault(require("../SelectionControlButton.module.scss"));
var ClearButton = function () {
    var selectionState = (0, provider_1.useSelectionContext)().selectionState;
    var filteredOptions = Array.from(selectionState.collection.getKeys());
    var selectedOptions = Array.from(selectionState.selectionManager.selectedKeys);
    var isDisabled = filteredOptions.length === 0 ||
        !Boolean(filteredOptions.find(function (key) {
            return selectionState.selectionManager.isSelected(key);
        }));
    return (react_1["default"].createElement("button", { type: "button", className: (0, classnames_1["default"])(SelectionControlButton_module_scss_1["default"].button, isDisabled && SelectionControlButton_module_scss_1["default"].isDisabled), "aria-disabled": isDisabled, onClick: function () {
            !isDisabled &&
                selectionState.selectionManager.setSelectedKeys(selectedOptions.filter(function (option) { return !filteredOptions.includes(option); }));
        } },
        "Clear",
        react_1["default"].createElement(a11y_1.VisuallyHidden, null, " selections")));
};
exports.ClearButton = ClearButton;
//# sourceMappingURL=ClearButton.js.map